
import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from 'frame'
import { createNavigation } from './navigation'
import { useIsWhiteListed, useCurrentRole, useTfsBornUser } from 'utils'
import { Page404 } from 'frame/components'
import { getAppConfig } from 'app-config'

import {
  ModuleRoutes as UsersRoute
} from 'features/admin-users'

import {
  ModuleRoutes as InvitationsRoute
} from 'features/admin-invitations'

import {
  ModuleRoutes as RegistrationOfInterestRoute
} from 'features/admin-registration-of-interest'

import {
  ModuleRoutes as FeatureTogglesRoute
} from 'features/feature-toggle'

import {
  ModuleRoutes as FeatureTogglesSettingsRoute
} from 'features/feature-toggle-settings'

const AdminRoute = () => {
  const config = getAppConfig()
  const currentRole = useCurrentRole()
  const navigation = createNavigation()
  const isWhiteListedUser = useIsWhiteListed()
  const isTfsBornUser = useTfsBornUser()

  const hideForNonSuperAdmin = !currentRole.includes('superadmin')
  const hideFeatureTogglesRoute =
    (config.env === process.env.REACT_APP_TFSDEMO_ENV ||
     config.env === process.env.REACT_APP_TFSUAT_ENV)
      ? !isTfsBornUser
      : !isWhiteListedUser

  let filteredNavigation = navigation

  filteredNavigation[0].pages = hideForNonSuperAdmin
    ? navigation[0].pages.filter(n => n.title !== 'Registration Of Interests')
    : navigation[0].pages

  filteredNavigation[0].pages = hideFeatureTogglesRoute
    ? navigation[0].pages.filter(n => n.title !== 'Feature Toggles')
    : navigation[0].pages

  filteredNavigation[0].pages = hideForNonSuperAdmin
    ? navigation[0].pages.filter(n => n.title !== 'Settings - MyDrive')
    : navigation[0].pages

  return (
    <Layout navigation={filteredNavigation}>
      <Routes>
        <Route path="users/*" element={<UsersRoute />} />
        <Route path="user-invitations/*" element={<InvitationsRoute />} />

        <Route
          path="registration-of-interest/*"
          element={
            hideForNonSuperAdmin
              ? <Page404 withoutNav />
              : <RegistrationOfInterestRoute />
          }/>

        <Route
          path="feature-toggles/*"
          element={
            hideFeatureTogglesRoute
              ? <Page404 withoutNav />
              : <FeatureTogglesRoute />
          }/>

        <Route
          path="mydriveapp-feature-toggles/*"
          element={
            hideForNonSuperAdmin
              ? <Page404 withoutNav />
              : <FeatureTogglesSettingsRoute />
          }/>

        <Route
          path=""
          element={<Navigate to="users" replace />}/>
      </Routes>
    </Layout>
  )
}

export default AdminRoute
